var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftMenu",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', {
    staticClass: "leftMenu_c"
  }, [_c('li', {
    on: {
      "click": _vm.goSaves
    }
  }, [_vm._v("我的收藏")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.emitSet
    }
  }, [_vm._v("阅读设置")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_vm._v("给个好评")]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-273ac036","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/leftMenu.vue
// module id = 9Vad
// module chunks = 1